import { createAction, createAsyncAction } from 'typesafe-actions';
import { TrustDocumentsResponse } from '../types';

const TRUST_DOCUMENTS_REQUEST = 'trustDocuments/FETCH_TRUST_DOCUMENTS/request';
const TRUST_DOCUMENTS_SUCCESS = 'trustDocuments/FETCH_TRUST_DOCUMENTS/success';
const TRUST_DOCUMENTS_FAILURE = 'trustDocuments/FETCH_TRUST_DOCUMENTS/failure';
const TRUST_DOCUMENTS_CANCEL = 'trustDocuments/FETCH_TRUST_DOCUMENTS/cancel';
const TRUST_DOCUMENTS_RESET = 'trustDocuments/RESET_TRUST_DOCUMENTS';

export const FETCH_TRUST_DOCUMENTS = createAsyncAction(
  TRUST_DOCUMENTS_REQUEST,
  TRUST_DOCUMENTS_SUCCESS,
  TRUST_DOCUMENTS_FAILURE,
  TRUST_DOCUMENTS_CANCEL,
)<void, TrustDocumentsResponse, Error, void>();

export const RESET_TRUST_DOCUMENTS = createAction(TRUST_DOCUMENTS_RESET)<void>();
